module.exports = __webpack_public_path__ + "img/5.856a1428.png";